<script>
import {getPictureUrl, formatDate} from "@/lib";
import RichText from "@/components/ui/RichText.vue";

export default {
  name: "PastEventCard",
  components: {RichText},
  props: ["event"],
  methods: { getPictureUrl, formatDate }
}
</script>

<template>
  <router-link class="event-link" :to="`/veranstaltungen/${this.event.id}`">
    <v-card class="mt-4 event-card past-event-card">
      <div class="d-flex flex-row">
        <v-img :src="getPictureUrl(event.Bilder[0])" class="past-event-img flex-grow-0" width="244" height="163"></v-img>
        <div class="past-event-card-content">
          <div class="title-badges">
            <v-chip color="grey lighten-1" x-small label class="material-typ-badge mr-2">Abgeschlossen</v-chip>
            <v-chip color="grey lighten-1" x-small label class="material-typ-badge mr-2">{{ formatDate(event.Termin.Datum) }}</v-chip>
            <v-chip color="grey lighten-1" x-small label class="material-typ-badge">{{event.Adresse.Ort }}</v-chip>
          </div>
          <div class="event-title primary-text mb-1">{{ event.Titel }}</div>
          <rich-text  class="event-text" :markdown-text="event.Text" show-plain-text />
        </div>
      </div>
    </v-card>
  </router-link>
</template>

<style scoped>
.past-event-card-content {
  padding: 16px 16px 0;
}

.event-title {
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
}

.event-text {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
}

.past-event-img {
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
}
</style>